import React from "react";

import { Icon, IconProps } from "../";

export const StarOffIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3331 10.4314L14.8739 13.4287L15.9095 17.8816L12.0014 15.5179L8.09018 17.8741L9.1261 13.429L5.66979 10.4342L10.218 10.0481L12.0003 5.84217L13.7817 10.0364L18.3331 10.4314ZM11.5367 4.75056L11.5383 4.75438ZM3.78983 10.79L7.45983 13.97L6.35983 18.69C6.15983 19.55 7.08983 20.23 7.84983 19.77L11.9998 17.27L16.1498 19.78C16.9098 20.24 17.8398 19.56 17.6398 18.7L16.5398 13.97L20.2098 10.79C20.8798 10.21 20.5298 9.11 19.6498 9.04L14.8098 8.62L12.9198 4.17C12.5798 3.36 11.4198 3.36 11.0798 4.17L9.18983 8.63L4.35983 9.04C3.47983 9.11 3.11983 10.21 3.78983 10.79Z"
      />
    </Icon>
  );
};
